import React from 'react';
import LoginButton from '../components/LoginButton';
import TopBody from '../components/TopBody';
import RecsiteAPI from '../service/RecsiteAPI';
import moment from 'moment';
import JobDescription from '../components/VacancyOverview/JobDescription';
import KeyInformation from '../components/VacancyOverview/KeyInformation';
import ApplyButton from '../components/VacancyOverview/ApplyButton';
import PoweredBy from '../components/PoweredBy';
import config from '../config/constants';
import IFrameService from '../service/IFrameService';

export default class VacancyOverview extends React.Component {
	
	state = {
		vacancy: {
			jobTitle: 'Vacancies',
			
		}
	};
	
	componentDidMount = () => {
		RecsiteAPI.getVacancyById(this.props.match.params.vacancyId).then(data => {
			console.log(data, 'data of JOB');
			this.setState({
				vacancy: {
					jobId: data.vacancy_id ? data.vacancy_id : 0,
					jobTitle: data.title ? data.title : 'none',
					jobDescription: data.description ? data.description : 'none',
					jobType: data.duration ? data.duration : 'none',
					postedDate: data.postdate ? moment(data.postdate).format('DD/MM/YYYY') : 'none',
					startDate: data.startdate ? moment(data.startdate).format('DD/MM/YYYY') : 'none',
					contact: data.consultant ? data.consultant.name : 'none',
					salary: data.salary_level ? data.salary_level.name : 'none'
				}
			}, IFrameService.parentData())
		});
	};
	
	componentDidUpdate = () => {
		IFrameService.parentData();
	};
	
	render = () => {
		
		return (
			<div className="container">
				
				<LoginButton/>
				
				<TopBody className="vacancies-overview-top" header={`We're looking for a`} title={this.state.vacancy.jobTitle}/>
				
				<JobDescription text={this.state.vacancy.jobDescription}/>
				
				<KeyInformation vacancy={this.state.vacancy}/>
				
				<ApplyButton
					vacancyId={this.state.vacancy.jobId}
					target="__blank"
					href={`${config.PROTOCOL}://${config.DOMAIN}/vacancy-apply-front/job/${this.state.vacancy.jobId}`}
				/>
				
				<PoweredBy />
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/pages/VacancyOverview.js